import React, { createContext, useContext, useState } from "react";
import type { LanguageSelection } from "../interfaces/LanguageSelection";

const LanguageSelectionContext = createContext<{
  languageSelection?: LanguageSelection;
  setLanguageSelection: (selection: LanguageSelection | undefined) => void;
}>({
  languageSelection: undefined,
  setLanguageSelection: () => {},
});

export const LanguageSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [languageSelection, setLanguageSelection] = useState<LanguageSelection | undefined>(undefined);
  return (
    <LanguageSelectionContext.Provider value={{ languageSelection, setLanguageSelection }}>
      {children}
    </LanguageSelectionContext.Provider>
  );
};

export const useLanguageSelection = () => useContext(LanguageSelectionContext);